'use strict';

var index_styled = require('./chunks/index.styled2.js');
require('styled-components');
require('@userzoomlibraries/toolkit-theme-manager/get-theme-by-props');
require('react');
require('@userzoomlibraries/toolkit-icon');
require('./chunks/index.styled.js');
require('@userzoomlibraries/toolkit-js-utils/prop-types');
require('@userzoomlibraries/toolkit-js-utils/noop');
require('@userzoomlibraries/toolkit-js-utils/is-function');
require('@userzoomlibraries/toolkit-js-utils/is-string');
require('@userzoomlibraries/toolkit-react-utils/use-async-handlers');
require('@userzoomlibraries/toolkit-react-utils/use-aria-attributes');
require('@userzoomlibraries/toolkit-react-utils/use-data-attributes');
require('@userzoomlibraries/toolkit-react-utils/use-tab-index-attribute');
require('react/jsx-runtime');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

module.exports = index_styled.IconButton;
